<template lang="pug">
    multiselect(
        :value="value"
        :options="currencyList"
        placeholder="Type to search",
        label="currency_code"
        track-by="currency_code"
        name="currency"
        @input="onInput"
        :disabled="disabled"
        :loading="currency_loading"
        :internalSearch="false"
        @search-change="loadCurrency"
    )
        template(slot="option" slot-scope="props")
            span.block {{ props.option.description }} ({{ props.option.currency_code }}) ({{ props.option.currency_symbol }})
</template>

<script>
import currency from '@js/store/modules/currency';

export default {
    props: {
        value: {
            type: null,
            default: () => null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            currencyList: [],
            currency_loading: false,
        };
    },

    beforeCreate() {
        if (!this.$store.hasModule('currency')) {
            this.$store.registerModule('currency', currency);
        }
    },

    mounted() {
        this.loadCurrency();
    },

    methods: {
        onInput(value) {
            this.$emit('input', value);
        },

        loadCurrency: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.currency');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.currency_loading = true;
            this.$http.get(api, options).then(response => {
                this.currencyList = response.data.data;
                this.currency_loading = false;
            });
        }, 500),
    },
};
</script>
